import styled from 'styled-components';
import { Input } from 'antd';

export const StyledInputPassword = styled(Input.Password)`
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  color: rgba(22, 23, 26, 1);
  border: 1px solid ${({ theme }) => theme.palette.neutral[300]};

  &:hover,
  &:focus,
  &:focus-within {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  &.ant-input-affix-wrapper-disabled {
    .ant-input-disabled {
      color: ${({ theme }) => theme.palette.text.primary};
      -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
    }

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
      box-shadow: none !important;
    }
  }

  .ant-input-prefix {
    margin-inline-end: 8px;
    .anticon {
      font-size: 16px;
    }
  }
`;
